import request from '../../axios';
import {IGetBankValidationDataResponse} from './types';

export const getBankValidationData = async (loanGuid?: string) => {
  const {data}: {data: IGetBankValidationDataResponse} = await request.get(
    `/api/v2/payment/bank-validation/completed/loan-request/` + loanGuid,
  );

  return data;
};
